import { configureClinical } from '@parsina/framework/clinical/src/host.jsx';
import { onSessionEvent, SessionEvent } from '@parsina/framework/clinical/src/lib/session.js';
import { DOCTOR_BFF_URL } from './runtimeEnv.js';
import {
  getToken, getRefresh, getValidToken, refreshAccessToken, logout, parseJwt, isTokenExpired,
  redirectToLogin,
} from './auth.js';

// The clinic panel as a HOST of the clinical module (docs/CLINICAL_KIT_DESIGN.md).
//
// The visit room and the patient record are @parsina/framework/clinical — the
// SAME code the doctor panel renders. A doctor who also runs this clinic works
// them here, inside this panel, instead of being sent to another app. Two facts
// make that work without a line of clinical logic living in this repo:
//
//   1. They talk to the DOCTOR BFF, not this panel's. That is where visits,
//      notes, orders and the AI are, and it scopes every one of them to the
//      token's `sub` — this panel's token is the same Keycloak client's, so the
//      doctor BFF sees the same person it would in the doctor panel. The clinic
//      BFF exposes none of those operations and must not grow copies of them.
//   2. They send NO clinic header. The doctor BFF would read `x-active-clinic-id`
//      into the clinic of every write — orders, invoices — so the visit makes
//      exactly the requests it makes in the doctor panel.
//
// Imported first by App.jsx: configuration must precede the first render.

let clinicId = '';

/** Called by ClinicalFrame as the active clinic changes. The upload default. */
export function setClinicalClinicId(id) {
  clinicId = id || '';
}

configureClinical({
  bffUrl: DOCTOR_BFF_URL,
  auth: { getToken, getRefresh, getValidToken, refreshAccessToken, logout, parseJwt, isTokenExpired },
  activeClinicId: () => clinicId,
});

// A dead session inside a visit ends the way it does everywhere else in this
// panel: back through Keycloak, to the page the person was on (redirectToLogin
// stashes it). The visit room keeps its own unsaved draft across that trip.
onSessionEvent((event) => {
  if (event === SessionEvent.EXPIRED) redirectToLogin();
});
